import React, { useState, useEffect, useRef } from "react";
import { DownArrow } from "../../assets/svg";

const Dropdown = ({
  placeholder = "",
  placeholderClassName,
  value,
  onChange,
  options,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="relative h-[56.3px]">
      <div
        className={`absolute top-0 left-0 bg-[#2C2D36] border border-[#444444] w-full ${
          open ? "rounded-3xl z-10" : "rounded-full"
        }`}
      >
        <button
          type="button"
          className="w-full flex items-center justify-between cursor-pointer p-4"
          onClick={() => setOpen(!open)}
        >
          {value ? (
            <span className="text-white text-sm">{value.label}</span>
          ) : (
            <span className={`text-sm ${placeholderClassName ?? ""}`}>
              {placeholder}
            </span>
          )}
          <DownArrow
            className={`mr-1.5 transition-transform duration-200 ${
              open ? "rotate-180" : ""
            }`}
          />
        </button>

        {open ? (
          <div className="border-t border-[#444444]">
            <ul className="max-h-[200px] overflow-y-auto px-4 hide-scrollbar">
              {options.map((option) => (
                <li
                  key={option.id}
                  className="cursor-pointer border-b border-[#444444] last:border-b-0 py-[10px] text-sm"
                  onClick={() => {
                    setOpen(false);
                    onChange(option);
                  }}
                >
                  <button type="button">{option.label}</button>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export const DropdownTypable = ({
  placeholder = "",
  placeholderClassName,
  value,
  onChange,
  options,
}) => {
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const handleKeyDownInput = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (filteredOptions.length > 0) {
        onChange(filteredOptions[0]);
        setSearch("");
        setOpen(false);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setFilteredOptions(
      options.filter((option) =>
        option.label.toLowerCase().includes(search.trim().toLowerCase())
      )
    );
  }, [search, options]);

  return (
    <div ref={dropdownRef} className="relative h-[56.3px]">
      <div
        className={`absolute top-0 left-0 bg-[#2C2D36] border border-[#444444] w-full ${
          open ? "rounded-3xl z-10" : "rounded-full"
        }`}
      >
        <div
          className="w-full flex items-center justify-between cursor-pointer p-4"
          onClick={() => setOpen(!open)}
        >
          <div className="flex-grow text-left">
            {open ? (
              <input
                autoFocus
                type="text"
                className="bg-[#2C2D36] text-sm placeholder-[#5d5d64] focus:outline-none"
                placeholder={placeholder}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={handleKeyDownInput}
              />
            ) : value ? (
              <span className="text-white text-sm">{value.label}</span>
            ) : (
              <span className={`text-sm ${placeholderClassName}`}>
                {placeholder}
              </span>
            )}
          </div>
          <DownArrow
            className={`mr-1.5 transition-transform duration-200 ${
              open ? "rotate-180" : ""
            }`}
          />
        </div>

        {open ? (
          <div className="border-t border-[#444444]">
            <ul className="max-h-[200px] overflow-y-auto px-4 hide-scrollbar">
              {filteredOptions?.length ? (
                filteredOptions.map((option) => (
                  <li
                    key={option.id}
                    className="cursor-pointer border-b border-[#444444] last:border-b-0 py-[10px] text-sm"
                    onClick={() => {
                      setOpen(false);
                      onChange(option);
                    }}
                  >
                    <button type="button">{option.label}</button>
                  </li>
                ))
              ) : (
                <li className="cursor-pointer border-b border-[#444444] last:border-b-0 py-[10px] text-sm">
                  Option Not Found
                </li>
              )}
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Dropdown;
